import { Address } from "viem";
import { IS_TESTNET } from "~/core/constants";

const prefix = IS_TESTNET ? 'testnet' : 'mainnet'

export class Storage {
  private key;

  constructor(key: string) {
    this.key = `${prefix}-${key}`
  }

  get() {
    return localStorage.getItem(`${this.key}`)
  }

  set(value: string) {
    return localStorage.setItem(`${this.key}`, value)
  }

  remove() {
    localStorage.removeItem(`${this.key}`)
  }
}

export class StorageByAddress {
  private key;

  constructor(key: string) {
    this.key = `${prefix}-${key}`
  }

  get(address: Address) {
    return localStorage.getItem(`${this.key}-${address}`)
  }

  set(address: Address, value: string) {
    return localStorage.setItem(`${this.key}-${address}`, value)
  }

  remove(address: Address) {
    localStorage.removeItem(`${this.key}-${address}`)
  }
}

export const apiAuthTokenStorage = new StorageByAddress('api-token')
export const twitterAuthRedirectStorage = new Storage('twitter-auth-redirect')
export const sfxVolumeStorage = new Storage('volume') // keep legacy key so existing preference is preserved
export const volumeStorage = sfxVolumeStorage
export const bgmVolumeStorage = new Storage('bgm-volume')

export const blinkoReferralCodeStorage = new Storage('blinko-referral-code')
export const blinkoAutoReferralCodeStorage = new Storage('blinko-auto-referral-code')
export const blinkoAnnouncementStorage = new Storage('blinko-announcement')
export const blinkoHardModeStorage = new Storage('blinko-hard-mode')